import { render, staticRenderFns } from "./elecWiredPid.vue?vue&type=template&id=3b629c4e"
import script from "./elecWiredPid.vue?vue&type=script&lang=js"
export * from "./elecWiredPid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b629c4e')) {
      api.createRecord('3b629c4e', component.options)
    } else {
      api.reload('3b629c4e', component.options)
    }
    module.hot.accept("./elecWiredPid.vue?vue&type=template&id=3b629c4e", function () {
      api.rerender('3b629c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/chd/elecWiredPid.vue"
export default component.exports